
import React from 'react'

export default function NoPermission (props) {
    return <div style={{
        padding: "2rem"
    }}>您没有权限访问</div>
}